import { useEffect, useState } from "react";

export function useTonPrice() {
  const [tonPrice, setTonPrice] = useState<number | null>(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const res = await fetch(
          "https://api.coingecko.com/api/v3/simple/price?ids=the-open-network&vs_currencies=usd"
        );
        const data = await res.json();
        if (data["the-open-network"]) {
          setTonPrice(data["the-open-network"].usd);
        }
      } catch (err) {
        console.error("Error fetching TON price", err);
      }
    };
    fetchPrice();
  }, []);

  return tonPrice;
}
